import { CloseOutlined, CodeOutlined, CopyOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Space } from 'antd';

type CartModalProps = {
  eventId: string;
  open: boolean;
  onClose: () => void;
};

const faqLink =
  'https://ajuda.eduzz.com/hc/pt-br/articles/4406141586971-Como-adicionar-o-Script-Widget-em-minha-p%C3%A1gina-de-vendas-Blinket';

export const EventCartModal = ({ eventId, open, onClose }: CartModalProps) => {
  const scriptWidget = `<div id="blk_v3"></div>
  <script>
    eval(atob("dmFyIGxvYWRXaWRnZXQgPSBmdW5jdGlvbihjb25maWcpIHsNCiAgICAgICAgICAgICAgICB3aW5kb3cuYmxpbmtldCA9IE9iamVjdC5hc3NpZ24od2luZG93LmJsaW5rZXQsIGNvbmZpZyk7DQogICAgICAgICAgICAgICAgY29uc3QgZGF0ZSA9IG5ldyBEYXRlKCkuZ2V0VGltZSgpOw0KICAgICAgICAgICAgICAgIGRvY3VtZW50LndyaXRlKCc8c2NyaXB0IHNyYz0iaHR0cHM6Ly9jZG4uZWR1enpjZG4uY29tL2JsaW5rZXQtd2lkZ2V0L2JsaW5rZXQtd2lkZ2V0LmpzPycgKyBkYXRlICsgJyI+PFwvc2NyaXB0PicpOw0KICAgICAgICAgICAgfQ0KICAgICAgICAgICAgd2luZG93LmJsaW5rZXQgPSB7DQogICAgICAgICAgICAgICAgc3RhcnQ6IGxvYWRXaWRnZXQNCiAgICAgICAgICAgIH07"))

    blinket.start({
      selector: '#blk_v3',
      id: '${eventId}', /* Este é o ID de seu evento */
      template: 'v3'
    });
  </script>`;

  return (
    <Modal
      open={open}
      closable
      title='Integre nosso Widget diretamente no seu site'
      closeIcon={<CloseOutlined onClick={onClose} id='close-icon-eventcart-modal' />}
      footer={
        <div style={{ display: 'flex', justifyContent: 'end', alignContent: 'center', gap: '8px' }}>
          <Button onClick={onClose} id='close-btn-eventcart-modal'>
            Fechar
          </Button>
          <Button
            type='primary'
            onClick={() => {
              navigator.clipboard.writeText(scriptWidget);
            }}
            icon={<CopyOutlined />}
            id='copy-btn-eventcart-modal'
          >
            Copiar código
          </Button>
        </div>
      }
    >
      <p style={{ color: '#00000073', fontSize: '14px' }}>
        Basta copiar o script abaixo e colá-lo no seu código para que seu público escolha os ingressos sem sair do seu
        site:
      </p>
      <br />
      <Input.TextArea value={scriptWidget} rows={10} disabled style={{ marginBottom: '15px' }} />
      <Space align='start'>
        <CodeOutlined style={{ color: '#FFBC00', fontSize: '30px' }} />
        <div>
          <p style={{ fontWeight: 'bold', fontSize: '16px' }}> Ficou com alguma dúvida? </p>
          <p style={{ color: '#00000073', fontSize: '14px' }}>
            Acesse nossa{' '}
            <a
              href={faqLink}
              target='_blank'
              rel='noreferrer'
              style={{ color: '#00000073', textDecoration: 'underline' }}
            >
              Central de Ajuda
            </a>{' '}
            e descubra, passo a passo, como conectar nosso Widget à sua página.
          </p>
        </div>
      </Space>
    </Modal>
  );
};
